import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';
import { getCart } from './cart';

export function loginRequired() {
    return {
        type: ActionType.LOGIN_REQUIRED
    }
}

export function doLogin(username, password) {
    
    return (dispatch, getState) => {

        const currentLocale = getCurrentLocale(getState());

        api.login(username, password, currentLocale)
            .then(function(response) {
                if (response.status == 400) {
                    dispatch(loginError());
                    const error = new Error(response.statusText);
                    error.response = response;
                    throw error;
                }
                return response.json()
            })
            .then(data => {
                dispatch(loginSuccess(data));
                dispatch(fetchUserStatus());
                dispatch(getCart());
                dispatch(closeLoginModal());
            })
            .catch(error => {
                console.log(`Request failed: ${error}`);
            });
    };
}

function loginSuccess(json)
{
    return {
        type: ActionType.LOGIN_SUCCESS,
        payload: json
    }
}

function loginError() {
    return {
        type: ActionType.LOGIN_ERROR
    }
}

function logoutSuccess() {
    return {
        type: ActionType.LOGOUT_SUCCESS
    }
}

function logoutError() {
    return {
        type: ActionType.LOGOUT_ERROR
    }
}

export function openLoginModal() {
    return {
        type: ActionType.LOGIN_MODAL_OPEN
    }
}

export function closeLoginModal() {
    return {
        type: ActionType.LOGIN_MODAL_CLOSE
    }
}

export function getUserStatus() {
    return (dispatch, getState) => {
        if ( isUserAuthenticated(getState()) ) {
            return Promise.resolve();
        } else {
            return dispatch(fetchUserStatus());
        }
    };
}

export function isUserAuthenticated(globalState) {
    return globalState.user.isAuthenticated;
}

// @see : http://redux.js.org/docs/advanced/AsyncActions.html
export function fetchUserStatus() {

    return function (dispatch, getState) {

        return api.getUserStatus()
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(data => {
                dispatch(userStatusSuccess(data));
            })
            // .catch(error => {
            //     console.log(`Request failed: ${error}`);
            // })
            ;
    }
}

function userStatusSuccess(data) {
    return {
        type: ActionType.USER_STATUS_SUCCESS,
        payload: data
    }
}

export function doLogout() {
    return (dispatch, getState) => {

        const currentLocale = getCurrentLocale(getState());

        api.logout(currentLocale)
            .then(function(response) {
                if (response.status !== 200) {
                    // dispatch(logoutError());
                    // const error = new Error(response.statusText);
                    // error.response = response;
                    // throw error;
                }

                return response.status;
            })
            .then(data => {
                dispatch(logoutSuccess());
            })
            //.catch(error => {
            //    console.log(`Request failed: ${error}`);
            //})
        ;
    };
}

function getCurrentLocale(globalState) {
    let locale = 'en_GB';
    if (globalState.intl && globalState.intl.locale) {
        locale = globalState.intl.locale.replace(/-/,'_'); // de-DE -> de_DE
    }

    return locale;
}


// WEBPACK FOOTER //
// ./src/js/actions/user.js